import React, { useState } from "react";
import Contact from "../contact";
// import Question from "../question";
import arrowIcon from "../../images/home/arrow-icon.svg";
import bannerImage from "../../images/aboutUs/about.png";
import ourVission from "../../images/aboutUs/OurVision.jpg";
import ourMission from "../../images/aboutUs/OurMission.jpg";
import starIcon from "../../images/aboutUs/ri_star-line.svg";
import rightIcon from "../../images/aboutUs/right-icon.svg";
import iconright from "../../images/individual/PHONESVG.svg";
import iconleft from "../../images/individual/EMAILSVG.svg";
import aboutImageright from "../../images/aboutUs/Bhoomika_new.jpg";
import leftcontent from "../../images/aboutUs/ravin.jpg";
import isthiaDsc from "../../images/aboutUs/ishita.jpg";
import coreTopLeft from "../../images/individual/coreTopleft.svg";
import corebootomLeft from "../../images/individual/Group.png";
import middleimage from "../../images/individual/CoreValue.png";
import collobration from "../../images/individual/connected-persons-triangle-svgrepo-com 1.png";
import excellent from "../../images/individual/medal-svgrepo-com 1.png";
import blubmiddle from "../../images/individual/bulb-on-svgrepo-com 1.png";
import iconlinkedin from "../../images/footer/linkdins.png";
import closeIcon from "../../images/home/right-arrow.svg";
import { Helmet } from "react-helmet-async";

// Team member images
import nicoleImage from "../../images/aboutUs/Nicole.jpg";
import anshulImage from "../../images/aboutUs/Anshul.jpg";
import zeelImage from "../../images/aboutUs/Zeel.jpg";
import vivekImage from "../../images/aboutUs/Vivek.jpg";
import shivaniImage from "../../images/aboutUs/Shivani.jpg";
import ravinImage from "../../images/aboutUs/ravin.jpg";
import bhoomikhaImage from "../../images/aboutUs/Bhoomika_new.jpg";
import ishitaImage from "../../images/aboutUs/ishita.jpg";

const AboutUs = () => {
  const [selectedMember, setSelectedMember] = useState(null);
  
  // Team member data
  const teamMembers = [
    {
      id: 1,
      name: "Ravin Parekh",
      position: "Founder & Managing Director",
      email: "ravin@immigetglobal.com",
      phone: "+61 420 340 811",
      linkedin: "https://www.linkedin.com/in/ravin-parekh-03316774",
      bio: "Ravin Parekh, visionary founder and director, is driving innovation and growth at Immiget Global. Ravin is passionate about helping people achieve their Australian migration goals by drawing on both his professional expertise and personal experience as an international student. He has also undertaken formal study in Australian migration law, further strengthening his understanding of the migration framework and his ability to provide practical, well-informed guidance. With razor-sharp business acumen and a nuanced understanding of the Australian market, Ravin's leadership philosophy embraces individuality. By empowering others and fostering a culture of authenticity, he consistently brings out the best in his team while delivering exceptional outcomes for clients and partners.",
      initial: "RP",
      image: ravinImage,
      featured: true
    },
    {
      id: 2,
      name: "Bhoomika Godara",
      position: "Principal Migration Agent (MARN 2418453)",
      email: "bhoomika-aus@immigetglobal.com",
      phone: "+61 487 528 282",
      linkedin: "https://www.linkedin.com/in/bhoomikagodara",
      bio: "Bhoomika's passion for providing exceptional migration services stems from her personal experiences as an international student. With more than 8 years of experience in the migration field, she has been instrumental in helping many individuals and businesses achieve success by navigating their migration journeys. Starting her career as a migration administrator, Bhoomika's commitment to supporting others ultimately led her to earn her MARA migration license. Her diverse portfolio includes assisting students, graduates, employers, couples, and families.",
      initial: "BG",
      image: bhoomikhaImage,
      featured: true
    },
    {
      id: 3,
      name: "Dr. Ishita Patel",
      position: "Australian Medical Regulatory Advisor",
      email: "contact@immigetglobal.com",
      phone: "+61 420 340 811",
      linkedin: "https://www.linkedin.com/in/",
      bio: "Dr. Ishita Patel is currently working in Australia as a specialist trainee in Radiology. Having faced the challenging journey of an international medical graduate, she was inspired to support aspiring medical professionals who envisions to move to Australia as Doctors, At Immiget Global, Dr. Patel is responsible to guide overseas medical professionals through the regulatory requirements, exam preparation, ultimately, simplifying the migration for them.",
      initial: "IP",
      image: ishitaImage,
      featured: true
    },
    {
      id: 4,
      name: "Nicole Saville",
      position: "Business Development Consultant",
      email: "nicole@immigetglobal.com",
      phone: "+61 450 061 012",
      linkedin: "https://www.linkedin.com/in/nicole-saville-8136a672",
      bio: "Nicole is a results-driven Business Development Consultant at Immiget Global with 20+ years of expertise in project management, HR, and recruitment, specialising in optimising processes and driving business growth. Skilled in talent acquisition and workforce solutions, she excels at identifying opportunities, securing top talent, and fostering strong stakeholder relationships to deliver tailored strategies that ensure smooth and successful migration experiences for clients.",
      initial: "NS",
      image: nicoleImage
    },
    {
      id: 5,
      name: "Anshul Gupta",
      position: "Assistant Executive - Migration",
      email: "migration-admin@immigetglobal.com",
      phone: "+91 99250 17343",
      linkedin: "",
      bio: "Anshul Gupta is a skilled Migration Coordinator with 5+ years of experience in the migration industry. Starting her career at the front desk, she has developed expertise in end-to-end visa application management, meticulous documentation, and case coordination. Her strong attention to detail, organizational skills and attention to detail ensures efficient and successful outcomes for clients.",
      initial: "AG",
      image: anshulImage
    },
    {
      id: 6,
      name: "Shivani Tiwari",
      position: "Migration Assistant",
      email: "shivani-aus@immigetglobal.com",
      phone: "+61 437 414 080",
      linkedin: "https://www.linkedin.com/in/shivani-tiwari-58963123a",
      bio: "Shivani has over seven years of experience in the international education sector, specializing in student counselling and Australian education pathways. Currently a Migration Admin at Immiget, she supports clients through migration processes and helps ensure smooth transitions into Australia. Passionate about empowering students and migrants, Shivani is committed to creating positive outcomes and enjoys collaborating with others in the migration and education sectors.",
      initial: "ST",
      image: shivaniImage
    },
    {
      id: 7,
      name: "Vivek Modi",
      position: "Migration Case Manager",
      email: "vivek@immigetglobal.com",
      phone: "+61 452 461 024",
      linkedin: "https://www.linkedin.com/in/vikm91",
      bio: "Vivek moved to Australia to pursue a Master's in IT, gaining experience in sales and contact centre roles. After working in the IT industry until 2024, his own challenges with the Permanent Residency process sparked a passion for migration law. He is currently studying a Diploma in Migration Law and Practice to help others on their migration journey, working as a Migration Case Manager at Immiget Global.",
      initial: "VM",
      image: vivekImage
    },
    {
      id: 8,
      name: "Zeel Desai",
      position: "Visa and Application Officer - Onshore",
      email: "migration-apps1@immigetglobal.com",
      phone: "+91 99250 19556",
      linkedin: "https://www.linkedin.com/in/zeel-desai-a27356133",
      bio: "With 12 years of experience in the migration and travel industry, Zeel began her career as a Visa Administrator where she built a strong foundation in document verification, compliance, and applicant support. She is dedicated to simplifying the migration process, making it more accessible and less daunting for applicants. She guides individuals through every step with professionalism and care.",
      initial: "ZD",
      image: zeelImage
    }
  ];
  
  // Function to open modal with team member details
  const openMemberDetails = (member) => {
    setSelectedMember(member);
  };
  
  // Function to close modal
  const closeMemberDetails = () => {
    setSelectedMember(null);
  };
  
  return (
    <div>
      <Helmet>
        <title>
          {" "}
          Best Immigration Consultants in Australia | Immiget Global Australia
        </title>
        <meta
          name="description"
          content="Need visa or PR assistance? Immiget Global Australia's expert immigration consultants provide reliable and hassle-free solutions."
        />
      </Helmet>
      <div className="w-full h-90 font-Hellix bg-cover bg-center bg-image">
        <div className="max-w-[1440px] px-4 md:px-[75px] m-auto h-full ">
          <div className="flex flex-col gap-2 md:gap-2 pt-10 md:pt-20 pb-[90px] h-full justify-center">
            <div className="text-white  hellix-font  text-center font-semibold text-[24px] md:text-[54px]">
              About Immiget Global – Your Trusted Migration Partner
            </div>
            <div className="flex justify-center  gap-2 md:gap-4">
              <div className="text-white  hellix-font  text-sm flex items-center md:text-lg font-medium">
                HOME
              </div>
              <div className="flex items-center">
                <img src={arrowIcon} className="w-[5.8px] md:w-auto" alt="" />
                <img src={arrowIcon} className="w-[5.8px] md:w-auto" alt="" />
              </div>
              <div className="text-white hellix-font  text-sm flex items-center md:text-lg font-medium uppercase">
                About Us
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="w-full flex justify-between max-xl:flex-col  items-center gap-12 max-w-[1440px] px-4 md:px-12 mx-auto pt-14  mb-10">
        <div className="flex xl:w-[40%] max-xl:w-full justify-center">
          <img src={bannerImage} alt="banner-image" className="max-xl:w-full" />
        </div>
        <div className="xl:w-[60%] md:px-4 flex flex-col justify-center">
          <div className="flex gap-2">
            <div className="flex items-center">
              <img src={starIcon} alt="star-icon" />
            </div>
            <div className="text-[#004b6b] hellix-font text-lg  font-semibold">
              About Us
            </div>
          </div>
          <h1 className="text-[#004b6b] hellix-font text-[32px] max-md:text-[40px] font-semibold">
            Making Migration Simple, One Step at a Time
          </h1>
          <p className="text-[#545b5f] hellix-font  text-lg font-normal">
            At Immiget Global, we believe that everyone deserves a chance to
            start anew. Our mission is to empower individuals and families to
            achieve their dreams of a better life abroad, free from the
            complexities of migration processes. As a leading migration
            consultancy with footprints in Australia, India & Philippines, we
            bridge the gap between your aspirations and reality. Our team of
            registered migration agents provide transparency, clarity and navigates complex visa processes, 
            ensuring seamless transitions to settlement. Our mission remains to establish relationships and
            channels that deliver results and empower trust.  
          </p>
          <div className="md:shadow-custom p-4 md:p-8 mt-4 ">
            <div className="flex justify-center gap-10 max-sm:gap-2 max-sm:flex-col">
              <div className="flex gap-2">
                <div>
                  <img src={rightIcon} alt="" />
                </div>
                <div className="text-[#004b6b] hellix-font  text-lg font-medium">
                  Residency Consultation
                </div>
              </div>
              <div className="flex gap-2">
                <div>
                  <img src={rightIcon} alt="" />
                </div>
                <div className="text-[#004b6b] hellix-font  text-lg font-medium">
                  Work Permit Processing
                </div>
              </div>
            </div>
            <div className="flex justify-center gap-10 max-sm:gap-2 max-sm:flex-col">
              <div className="flex gap-2">
                <div>
                  <img src={rightIcon} alt="" />
                </div>
                <div className="text-[#004b6b] hellix-font  text-lg font-medium">
                  Family Sponsorship Aid
                </div>
              </div>
              <div className="flex gap-2">
                <div>
                  <img src={rightIcon} alt="" />
                </div>
                <div className="text-[#004b6b] hellix-font  text-lg font-medium">
                  Residency Permit Services
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Meet our team */}
      <div className="max-w-[1440px] px-4 lg:px-12 mx-auto lg:py-8 py-3">
        <h1 className="text-[#284760] hellix-font text-[32px] font-semibold text-center">
          Meet Our Team
        </h1>
        <div className="text-blue text-center hellix-font text-lg lg:text-xl mb-12">
          Meet our dedicated team of immigration experts committed to providing
          personalized guidance and support throughout your journey to
          Australia.
        </div>

        {/* Team Members Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10 mb-16">
          {teamMembers.map((member) => (
            <div 
              key={member.id} 
              className="relative group cursor-pointer"
              onClick={() => openMemberDetails(member)}
            >
              {/* Card Container */}
              <div className="relative h-[220px] md:h-[240px] overflow-hidden rounded-2xl transform transition-all duration-500">
                {/* Hover Card - Initially Hidden */}
                <div className="absolute inset-[10%] bg-[#004b6b] opacity-0 group-hover:opacity-100 transition-all duration-500 rounded-xl shadow-lg shadow-gray-600/20 z-20"></div>
                
                {/* Eye Icon (visible on hover) with animation */}
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-all duration-500 text-white z-30 text-center">
                  <svg 
                    xmlns="http://www.w3.org/2000/svg" 
                    className="h-12 w-12 mx-auto animate-pulse" 
                    fill="none" 
                    viewBox="0 0 24 24" 
                    stroke="currentColor"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                  </svg>
                </div>
                
                {/* Blob Shape Container - Higher z-index */}
                <div className="absolute inset-0 z-10 flex items-center justify-center transform group-hover:scale-[0.95] transition-all duration-500">
                  {/* Random Blob SVG - using different paths for each member */}
                  <div className="relative w-44 h-44 md:w-52 md:h-52">
                    <svg 
                      viewBox="0 0 200 200" 
                      xmlns="http://www.w3.org/2000/svg"
                      className="absolute inset-0 w-full h-full"
                    >
                      <path 
                        fill="#a1cedf" 
                        d={member.id % 4 === 0 ? 
                          "M44.9,-76.8C57.9,-71,68.4,-58.7,75.6,-44.6C82.8,-30.5,86.8,-15.2,86.7,-0.1C86.6,15.1,82.5,30.2,74.3,42.8C66.2,55.3,53.9,65.3,40.4,71.2C26.8,77.1,13.4,79,0.4,78.3C-12.7,77.7,-25.3,74.5,-38.8,69C-52.3,63.4,-66.6,55.4,-76,43.4C-85.4,31.3,-89.9,15.7,-87.1,1.6C-84.3,-12.5,-74.3,-25,-65.5,-37.5C-56.8,-50,-49.4,-62.5,-38.8,-69.6C-28.2,-76.7,-14.1,-78.5,1,-80.2C16.1,-82,32.2,-82.5,44.9,-76.8Z" : 
                          member.id % 3 === 0 ? 
                          "M42.7,-73.8C53.4,-65.4,59.1,-50.3,65.4,-36.3C71.8,-22.3,78.8,-11.2,79.9,0.6C81,12.4,76.1,24.9,69.2,36.2C62.4,47.6,53.4,57.9,42,64.7C30.5,71.5,15.3,74.9,0.9,73.4C-13.5,71.9,-27,65.6,-39.1,57.7C-51.2,49.7,-61.8,40.2,-69.9,28C-77.9,15.8,-83.2,0.8,-78.9,-10.9C-74.6,-22.7,-60.6,-31.2,-48.3,-40.1C-36,-49,-25.3,-58.3,-12.8,-64.3C-0.4,-70.2,13.9,-72.8,27.3,-72.9C40.8,-73,51.5,-70.6,42.7,-73.8Z" : 
                          member.id % 2 === 0 ? 
                          "M42.3,-73.3C52.7,-66.9,57.7,-50.8,63.4,-36.5C69.1,-22.2,75.6,-9.8,76.4,3.3C77.2,16.4,72.3,30.7,64.2,42.4C56.1,54.1,44.8,63.1,32.1,69.6C19.4,76.1,5.4,80.1,-8.2,79.4C-21.8,78.7,-35,73.4,-46.2,65.6C-57.4,57.9,-66.6,47.8,-71.9,35.8C-77.2,23.7,-78.6,9.9,-76.8,-3C-75,-15.9,-70,-27.7,-62.7,-38.1C-55.3,-48.5,-45.7,-57.4,-34.6,-62.8C-23.5,-68.3,-11.7,-70.3,1.7,-73.1C15.2,-75.9,30.4,-79.5,42.3,-73.3Z" : 
                          "M47.7,-80.1C59.4,-73.8,65.1,-56.8,70.9,-41.3C76.7,-25.9,82.6,-12.9,81.9,-0.4C81.2,12.1,74,24.3,65.7,34.9C57.5,45.5,48.3,54.6,37.4,62.4C26.4,70.2,13.2,76.7,-0.5,77.6C-14.3,78.5,-28.5,73.7,-41.3,66.5C-54,59.3,-65.3,49.6,-71.5,37.3C-77.8,25,-79,10,-76.3,-3.9C-73.5,-17.8,-66.8,-30.5,-58.2,-41.5C-49.7,-52.5,-39.2,-61.8,-27,-67.8C-14.7,-73.7,-0.8,-76.3,13,-78.1C26.9,-79.9,53.8,-80.8,47.7,-80.1Z" 
                        } 
                        transform="translate(100 100)"
                      />
                    </svg>
                    
                    {/* Member Image centered within blob */}
                    <div className="absolute w-28 h-28 md:w-32 md:h-32 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 rounded-full overflow-hidden z-20">
                      <img 
                        src={member.image} 
                        alt={member.name}
                        className="w-full h-full object-cover object-center" 
                      />
                    </div>
                  </div>
                </div>
              </div>
              
              {/* Member Name (Always visible) */}
              <div className="mt-0 text-center z-20 relative">
                <h3 className="text-xl font-semibold text-[#284760]">{member.name}</h3>
                <p className="text-blue text-sm opacity-80">{member.position}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      
      {/* Modal for Member Details */}
      {selectedMember && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4 animate-fadeIn">
          <div className="bg-white rounded-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto animate-scaleIn">
            <div className="relative p-6">
              {/* Close Button */}
              <button 
                onClick={closeMemberDetails}
                className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-full bg-blue/10 hover:bg-blue/20 transition-colors"
              >
                <span className="sr-only">Close</span>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 4L4 12M4 4L12 12" stroke="#004B6B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
              
              {/* Member Info Header */}
              <div className="flex items-center mb-6">
                <div className="w-20 h-20 rounded-full border-2 border-white shadow-md flex-shrink-0 mr-4 overflow-hidden">
                  <img 
                    src={selectedMember.image} 
                    alt={selectedMember.name}
                    className="w-full h-full object-cover object-center" 
                  />
                </div>
                <div>
                  <h3 className="text-2xl font-semibold text-[#284760]">{selectedMember.name}</h3>
                  <p className="text-blue text-lg">{selectedMember.position}</p>
                </div>
              </div>
              
              {/* Member Bio */}
              <div className="mb-6">
                <h4 className="text-xl font-semibold text-[#284760] mb-2">About</h4>
                <p className="text-[#004b6b] leading-relaxed">{selectedMember.bio}</p>
              </div>
              
              {/* Contact */}
              <div className="border-t border-gray-200 pt-4">
                <h4 className="text-xl font-semibold text-[#284760] mb-4">Contact</h4>
                <div className="flex flex-wrap gap-4">
                  <a 
                    href={`mailto:${selectedMember.email}`} 
                    className="flex items-center px-4 py-2 bg-blue/10 text-blue rounded-lg hover:bg-blue hover:text-white transition-colors"
                  >
                    <img src={iconleft} alt="Email" className="w-5 h-5 mr-2" />
                    <span>{selectedMember.email}</span>
                  </a>
                  
                  {selectedMember.phone && (
                    <a 
                      href={`tel:${selectedMember.phone.replace(/\s+/g, '')}`} 
                      className="flex items-center px-4 py-2 bg-blue/10 text-blue rounded-lg hover:bg-blue hover:text-white transition-colors"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                      </svg>
                      <span>{selectedMember.phone}</span>
                    </a>
                  )}
                  
                  {selectedMember.linkedin && (
                    <a 
                      href={selectedMember.linkedin} 
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center px-4 py-2 bg-blue/10 text-blue rounded-lg hover:bg-blue hover:text-white transition-colors"
                    >
                      <img src={iconlinkedin} alt="LinkedIn" className="w-5 h-5 mr-2" />
                      <span>LinkedIn</span>
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* {Vision and Mission} */}
      <div className="max-w-[1440px] px-4 lg:px-12 mx-auto">
        <div className="flex flex-col md:flex-row p-5 space-y-4 md:space-x-4 shadow-lg mt-8 hover:shadow-xl transition duration-300 bg-white rounded-lg mx-auto">
          <div className="w-full md:w-[25%] max-md:w-[100%] flex-shrink-0">
            <img src={ourVission} alt="Vision" className="max-md:w-[100%]" />
          </div>
          <div className="w-full md:w-[75%]">
            <div className="mb-4 ml-5 max-sm:ml-0">
              <h1 className="text-xl hellix-font  md:text-[32px] max-sm:text-center font-Hellix font-semibold text-[#004b6b] mb-2">
                Our Vision
              </h1>
              <p className="text-lg  hellix-font  md:text-[22px] max-md:text-left font-Hellix font-normal text-[#004b6b] max-w-full md:max-w-[839px]">
                Immiget Global envisions a world where migration is seamless,
                accessible, life-changing & easy. We strive to create a global
                community where people can freely explore opportunities,
                cultivate diversity, and thrive in their space with the choices
                they wish to make. We aim to be a go-to destination for clients
                who aspire to settle in Australia or anywhere else in the world.
                 
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="max-w-[1440px] px-4 sm:px-6 md:px-8 mt-4 lg:px-12 mx-auto mb-10">
        <div className="flex flex-col-reverse md:flex-row p-5 mt-5 space-y-4 md:space-x-4 shadow-lg hover:shadow-xl transition duration-300 bg-white rounded-lg mx-auto">
          <div className="w-full md:w-[70%]">
            <div className="">
              <h1 className="text-xl hellix-font  mt-6 sm:text-2xl max-sm:text-center max-md:mt-4 font-Hellix md:text-[32px] font-semibold text-[#004b6b] mb-2">
                Our Mission
              </h1>
              <p className="text-lg hellix-font  font-Hellix max-md:text-left sm:text-[22px] font-normal text-[#004b6b] max-w-full md:max-w-[900px]">
                At Immiget Global, our mission is to deliver expert migration
                solutions with integrity, and professionalism. We are committed
                to: 
                <br />
                Simplifying complex migration processes through smart
                practices and expert guidance. Providing personalized support
                and care to ensure a stress-free experience for our clients.
                Ensuring successful outcomes through meticulous application
                preparation and strategic representation. Developing a community
                of empowered global citizens through précised migration advice,
                awareness, and advocacy. 
              </p>
            </div>
          </div>
          <div className="w-full md:w-[25%] flex-shrink-0 max-md:w-[100%]">
            <img src={ourMission} alt="Mission " className="max-md:w-[100%]" />
          </div>
        </div>
      </div>
      <div className="container max-w-1440px mx-auto px-4 lg:px-14 py-10">
        <div className="flex justify-center items-center pb-10 mt-12">
          <div className="w-2 h-2 bg-blue rotate-45">.</div>
          <div className="w-[790px] h-[2px] bg-blue"></div>
          <div className="w-2 h-2 bg-blue rotate-45">.</div>
        </div>

        <div className="max-w-[1264px] text-center">
          <h1 className="text-[38px] text-blue hellix-font font-semibold">
            Our Core Values
          </h1>
          <p className="text-[22px] text-blue hellix-font font-normal">
            At Immiget Global, our core values serve as the bedrock of our
            migration practice, guiding our approach to delivering exceptional
            services to individuals and organizations navigating the
            complexities of global migration. 
          </p>
        </div>
      </div>
      <div className="lg:flex justify-center  container max-w-1440px  gap-[100px] px-4 mt-8 mb-8">
        <div className="flex flex-col lg:w-[330px] gap-10 lg:gap-20">
          <div
            className="w-[123px] flex justify-center items-center h-[123px] bg-[#ffffff] rounded-[61.5px] relative"
            style={{
              borderLeft: "3px solid #004b6b",
              boxShadow: "0px 3px 13px -10px rgba(0, 0, 0, 0.18)",
              zIndex: 1,
            }}
          >
            <img src={coreTopLeft} alt="core-left" />
            <div
              className="w-[236px] absolute top-[54px] left-[100px]  flex justify-center items-center text-blue text-xl font-semibold h-[94px]"
              style={{
                boxShadow: "10px 3px 13px 0px rgba(0, 0, 0, 0.18)",
                zIndex: 2,
                marginTop: "-40px",
                borderTopRightRadius: "60px",
                borderBottomRightRadius: "60px",
              }}
            >
              Empathy
            </div>
          </div>
          <div
            className="w-[123px] flex justify-center items-center h-[123px] bg-[#ffffff] rounded-[61.5px] relative"
            style={{
              borderLeft: "3px solid #004b6b",
              boxShadow: "0px 3px 13px -10px rgba(0, 0, 0, 0.18)",
              zIndex: 1,
            }}
          >
            <img src={corebootomLeft} alt="core-left" />
            <div
              className="w-[236px] absolute top-[54px] left-[100px]  flex justify-center items-center text-blue text-xl font-semibold h-[94px]"
              style={{
                boxShadow: "10px 3px 13px 0px rgba(0, 0, 0, 0.18)",
                zIndex: 2,
                marginTop: "-40px",
                borderTopRightRadius: "60px",
                borderBottomRightRadius: "60px",
              }}
            >
              Integrity
            </div>
          </div>
        </div>
        <div className="lg:w-[250px]">
          <div className="flex justify-center ml-6">
            <img src={middleimage} alt="middle-image" className="h-[350px]" />
          </div>
          <div>
            <div
              className="w-[123px] flex justify-center items-center h-[123px] bg-[#ffffff] rounded-[61.5px] relative"
              style={{
                borderLeft: "3px solid #004b6b",
                boxShadow: "0px 3px 13px -10px rgba(0, 0, 0, 0.18)",
                zIndex: 1,
              }}
            >
              <img src={blubmiddle} alt="core-left" />
              <div
                className="w-[236px] absolute top-[54px] left-[100px]  flex justify-center items-center text-blue text-xl font-semibold h-[94px]"
                style={{
                  boxShadow: "10px 3px 13px 0px rgba(0, 0, 0, 0.18)",
                  zIndex: 2,
                  marginTop: "-40px",
                  borderTopRightRadius: "60px",
                  borderBottomRightRadius: "60px",
                }}
              >
                Innovation
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col lg:w-[330px] max-lg:mt-4 gap-10 lg:gap-20">
          <div
            className="w-[123px] flex justify-center items-center h-[123px] bg-[#ffffff] rounded-[61.5px] relative"
            style={{
              borderLeft: "3px solid #004b6b",
              boxShadow: "0px 3px 13px -10px rgba(0, 0, 0, 0.18)",
              zIndex: 1,
            }}
          >
            <img src={excellent} alt="core-left" />
            <div
              className="w-[236px] absolute top-[54px] left-[100px]  flex justify-center items-center text-blue text-xl font-semibold h-[94px]"
              style={{
                boxShadow: "10px 3px 13px 0px rgba(0, 0, 0, 0.18)",
                zIndex: 2,
                marginTop: "-40px",
                borderTopRightRadius: "60px",
                borderBottomRightRadius: "60px",
              }}
            >
              Excellence
            </div>
          </div>
          <div
            className="w-[123px] flex justify-center items-center h-[123px] bg-[#ffffff] rounded-[61.5px] relative"
            style={{
              borderLeft: "3px solid #004b6b",
              boxShadow: "0px 3px 13px -10px rgba(0, 0, 0, 0.18)",
              zIndex: 1,
            }}
          >
            <img src={collobration} alt="core-left" />
            <div
              className="w-[236px] absolute top-[54px] left-[100px]  flex justify-center items-center text-blue text-xl font-semibold h-[94px]"
              style={{
                boxShadow: "10px 3px 13px 0px rgba(0, 0, 0, 0.18)",
                zIndex: 2,
                marginTop: "-40px",
                borderTopRightRadius: "60px",
                borderBottomRightRadius: "60px",
              }}
            >
              Collaboration
            </div>
          </div>
        </div>
      </div>

      <Contact />
      {/* <Question /> */}
    </div>
  );
};

export default AboutUs;